import React from "react";
import { Button, Table, Popup, Confirm } from "semantic-ui-react";
import startCase from "lodash/startCase";

class FilaContactos extends React.Component {
  state = {
    style: {}
  };

  onMouseEnter = () =>
    this.setState({
      style: { backgroundColor: "lavenderblush" }
    });

  onMouseLeave = () => this.setState({ style: {} });

  handleEditar = () => this.props.handleEditItem(this.props.datos.id);

  handleDefault = () => this.props.handleDefaultItem(this.props.datos.id);

  handleBorrar = () => this.setState({ verConfirm: true });

  handleBorrarCancela = () => this.setState({ verConfirm: false });

  handleBorrarConfirma = () => {
    this.setState({ verConfirm: false });
    this.props.handleBorrarItem(this.props.datos.id);
  };

  render() {
    const { datos } = this.props;
    return (
      <React.Fragment>
        <Table.Row>
          <Table.Cell content={startCase(datos.nombre)} collapsing />
          <Table.Cell content={datos.descripcion} collapsing />
          <Table.Cell content={datos.email} collapsing />
          <Table.Cell content={datos.telefono} collapsing />
          <Table.Cell content={datos.descripcion} collapsing />
          <Table.Cell content={datos.notas} />
          <Table.Cell collapsing>
            <Popup
              content="Marcar como forma por defecto"
              trigger={
                <Button
                  icon={datos.forma_principal ? "user" : "user outline"}
                  basic={!datos.forma_principal}
                  circular
                  onClick={this.handleDefault}
                  color={datos.forma_principal ? "green" : "grey"}
                />
              }
            />
            <Popup
              content="Editar Contacto"
              trigger={
                <Button
                  basic
                  icon="pencil"
                  circular
                  onClick={this.handleEditar}
                />
              }
            />
            <Popup
              content="Eliminar Contacto"
              trigger={
                <Button
                  basic
                  icon="trash"
                  circular
                  onClick={this.handleBorrar}
                />
              }
            />
          </Table.Cell>
        </Table.Row>

        <Confirm
          open={this.state.verConfirm}
          onCancel={this.handleBorrarCancela}
          onConfirm={this.handleBorrarConfirma}
          header="Se va a eliminar el contacto"
          content="¿Desea continuar?"
          cancelButton="No"
          confirmButton="si"
        />
      </React.Fragment>
    );
  }
}

export default FilaContactos;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaPersonaContacto/tablaContactos/FilaContactos.jsx